import { Component, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  DoppiaMaterialitaService,
  DoppiaSurvey,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { NgStarRatingService } from 'src/app/services/ng-star-rating/ng-star-rating.service';
import { AnteprimaDoppiaMaterialitaSuveyComponent } from '../anteprima-doppia-materialita-suvey/anteprima-doppia-materialita-suvey.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { TemaService } from 'src/app/services/tema/tema.service';

@Component({
  selector: 'app-doppia-survey-esterna',
  standalone: false,

  templateUrl: './doppia-survey-esterna.component.html',
  styleUrl: './doppia-survey-esterna.component.scss',
})
export class DoppiaSurveyEsternaComponent {
  @ViewChild('surveyDoppiaMat') surveyComponent!: AnteprimaDoppiaMaterialitaSuveyComponent;

  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public completato: boolean = false;
  public temporaryToken: string = '';
  public idSurvey: string = '';
  public idMaterialita: string = '';
  public idAzienda: string = '';
  public logoPath: string = 'assets/images/logo/logo-sostenibile.png';
  public messaggio: string = '';
  public landingPage: string = '';
  public doppiaSurveyEsterna: DoppiaSurvey | undefined = undefined;
  public surveyVuoto: boolean = false;
  public anteprima: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    public ngStarRatingService: NgStarRatingService,
    private readonly utilityService: UtilityService,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly temaService: TemaService,
  ) {
    this.temaService.temaUpdated.subscribe((tipoInstallazione) => {
      this.logoPath = temaService.logoPath;
    });
  }

  ngAfterViewInit(): void {
    this.parametriDaURL();
  }

  /**
   * Metodo che mi prende il token dal URL
   */
  public parametriDaURL() {
    // Sottoscrivo all'observable paramMap per ottenere i parametri dall'URL
    this.spinnerOver.show();
    this.route.queryParams.subscribe((params) => {
      this.temporaryToken = params['temporaryToken'];
      this.idMaterialita = params['id'];
      this.idAzienda = params['idA'];
    });
    if (this.temporaryToken) {
      this._getSurveyByTemporaryToken();
    } else if (this.idMaterialita && this.idAzienda) {
      this._getAnteprimaSurvey();
    } else {
      this.spinnerOver.hide();
    }
  }
  /**
   * Metodo che mi salva la survey compilata
   */
  salva() {
    if (this.doppiaMaterialitaService.isElementoNonCompilato(this.surveyComponent.datiSurvey)) {
      this.utilityService.openSnackBar('Rispondi a tutti gli IRO', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
      return;
    }

    this.spinnerOver.show();
    this.doppiaMaterialitaService
      .postDoppiaSurveyEsterna(this.temporaryToken, this.surveyComponent.datiSurvey)
      .subscribe({
        next: (esito) => {
          this.messaggio = 'Survey compilata. Grazie della sua disponibilità.';
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.messaggio = err.error.message;
          this.spinnerOver.hide();
        },
      });
    this.completato = true;
  }

  /**
   * Metodo che mi prende i dati della survey dal token
   */
  private _getSurveyByTemporaryToken() {
    this.anteprima = false;
    this.doppiaMaterialitaService.getDoppiaSurveyEsterna(this.temporaryToken).subscribe({
      next: (esito) => {
        this.doppiaSurveyEsterna = esito.questionarioDaCompilare;
        this.landingPage = esito.landing;
        this.surveyVuoto = false;
        this.spinnerOver.hide();
      },
      error: (err) => {
        console.error(err);

        this.messaggio = err?.error?.message || 'Nessun dato trovato';

        this.surveyVuoto = true;
        this.spinnerOver.hide();
      },
    });
  }

  private _getAnteprimaSurvey() {
    this.anteprima = true;

    this.doppiaMaterialitaService
      .getAnteprimaMaterialitaCompilataSurvey(this.idMaterialita, this.idAzienda, this.idSurvey)
      .subscribe({
        next: (esito) => {
          this.doppiaSurveyEsterna = esito.questionarioDaCompilare;
          this.landingPage = esito.landing || '';
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.messaggio = err?.error?.message || 'Nessun dato trovato';
          this.surveyVuoto = true;
        },
      });
  }
}
